module.exports = __webpack_public_path__ + "img/co2_white.55a5909b.svg";